import * as React from "react";
import Slider, { SliderThumb } from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PauseCircleIcon from '@mui/icons-material/PauseCircle';

const CheckMarkSlider = styled(Slider)(({ theme }) => ({
  color: "#3a8589",
  height: 3,
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: 20,
    width: 20,
    backgroundColor: "#FFD700", // Set icon and circle color to red
    border: "1px solid #FFD70", // Set icon and circle color to red
    "&:hover": {
      boxShadow: "0 0 0 0px #fff", // Set icon and circle color to red
    },
    "& .checkmark-bar": {
      height: 9,
      width: 1,
      backgroundColor: "#FFD700", // Set filled part color to green
      marginLeft: 1,
      marginRight: 1,
    },
  },
  "& .MuiSlider-track": {
    height: 7,
    backgroundColor: "#007E8C", // Set remaining part color to white
  },
  "& .MuiSlider-rail": {
    color: theme.palette.mode === "dark" ? "#bfbfbf" : "#F4F4F4",
    opacity: theme.palette.mode === "dark" ? undefined : 1,
    height: 6,
  },
}));

const CheckMarkThumbComponent = (props) => {
  const { children, ...other } = props;

  return (
    <SliderThumb {...other}>
      {children}
      <PauseCircleIcon sx={{ color: "#007e8c"}} />
    </SliderThumb>
  );
};

const CustomizedSlider = ({ value }) => {
  const [sliderValue, setSliderValue] = React.useState(0);

  React.useEffect(() => {
    setSliderValue(value);
  }, [value]);

  // const handleChange = (event, newValue) => {
  //   setSliderValue(newValue);
  // };

  return (
    <Box>
      <CheckMarkSlider
        value={sliderValue}
        // defaultValue={value}
        // onChange={handleChange}
        // disabled
        components={{ Thumb: CheckMarkThumbComponent }}
      />
    </Box>
  );
};

export default CustomizedSlider;
